<script setup lang="ts">
import { useAuth0 } from '@auth0/auth0-vue';
import { getLS } from '@marketspark/ui';

import { useBTitle } from '@/utils/browserTitle';

const { loginWithRedirect, isAuthenticated } = useAuth0();

useBTitle('Login');

const returnPath = getLS()?.ui?.returnPath || '/';

loginWithRedirect({ appState: { target: returnPath } });
</script>
<template>
  {{ isAuthenticated ? 'Loading...' : 'Logging in...' }}
</template>
